// @flow
// $FlowFixMe: useEffect requires flow-bin 0.82.
import React, {Component, useState, useEffect} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import createDebugger from 'debug';
const debug = createDebugger('app:components:MitreTagTooltipAndMetadata'); // eslint-disable-line no-unused-vars
import { ThemeType } from 'trustar-2.0/types';
import {List} from "immutable";
import {StyledTooltip} from './shared.styles';
import { capitalize } from 'trustar/utils';
import {thinScrollBar} from 'trustar-2.0/themes/common/globalSnippets.styles';

// Style for Main Components (things you may export)
const StyledMitreMetadataBox = styled.div`
  width: 25rem;
  max-height: 12rem;
  overflow-x: hidden;
  border-radius: 0.5rem;
  padding: 0.75rem;
  overflow-y: scroll;
  word-break: break-word;
  hyphens: auto;
  border: 1px solid ${({ theme }) => theme.ThemeColors.DARK.hex};
  h6 {
  font-size: 1.3rem;
    padding: 0 0 0.25rem 0;
    margin: 0;
    text-transform: capitalize;
  }
  
  a {
    display: block;
  }
  span {
    text-transform: capitalize;
    margin-bottom: 0.1rem;
    &:first-of-type {
      display: block;
    }
  }
  
  ${thinScrollBar}
`;

const initialValues = {
};

// Bindings
type MitreTagTooltipAndMetadataProps = {
  theme: ThemeType,
};


const MitreInfoTagTooltip = ({ mitreTagInfo, children, ...otherProps }: Object) => {
  // TODO Fallback?
  const metadata = mitreTagInfo.get('metadata');
  const subtype = mitreTagInfo.get('subtype');
  const isTechnique = subtype === 'technique';
  const isTactic = subtype === 'tactic';
  const humanizedTacticList = metadata.get('tactics', List())
    .map((tacticName, index, humanizedTacticList) => (tacticName === humanizedTacticList.last() ? capitalize(tacticName) : capitalize(tacticName) + ', '));

  return (
    <StyledTooltip noPadding {...otherProps}>
      <StyledMitreMetadataBox>
        <h6> {isTactic ? metadata.get('key') : metadata.get('technique')}</h6>
        <span><b>Type:</b> {subtype}</span>
        {isTechnique && <span className={'tactics-list'}> <b>Tactics:</b> {humanizedTacticList}</span>}
        <a target={'_blank'} href={metadata.get('externalUrl')}>See Full MITRE ATT&CK Entry</a>
        <p> <b> Description: </b> {metadata.get('description')}</p>
      </StyledMitreMetadataBox>
    </StyledTooltip>
  );
};


export {MitreInfoTagTooltip};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Tags/MitreTagTooltipAndMetadata.js